import { FC } from "react";
import { Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { CountryForm } from "../countryForm";
import { useCreateCountry } from "../dataHooks/countryQueries";

type Props = {};

export const NewCountry: FC<Props> = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const createCountry = useCreateCountry({
    onSuccess: () => navigate("/countries")
  });

  return (
    <Dialog
      maxWidth="md"
      fullWidth
      onClose={() => navigate("/countries")}
      open={location.pathname === "/countries/new"}
    >
      <DialogTitle>
        {/* Title kept in step with the menubar button that opens this dialog. */}
        <Typography variant="h5">Onboard New Country Addition</Typography>
      </DialogTitle>
      <DialogContent>
        <CountryForm
          onSubmit={(payload) => createCountry.mutate(payload)}
          submitting={createCountry.isPending}
          submitLabel="Create"
          onCancel={() => navigate("/countries")}
        />
      </DialogContent>
    </Dialog>
  );
};
